// extracted by mini-css-extract-plugin
export default {"confirmActionModal":"ConfirmActionModal_confirmActionModal__InxMw","infoText":"ConfirmActionModal_infoText__9I8sX","questionText":"ConfirmActionModal_questionText__plg46"};